export enum LoggerName {
  BannerError = 'BANNER_ERROR',
}
